import { Pipe, type PipeTransform } from '@angular/core';

interface InitialsSource {
  readonly firstName?: string | null;
  readonly lastName?: string | null;
  readonly username?: string | null;
}

@Pipe({
  name: 'mlInitials',
})
export class InitialsPipe implements PipeTransform {
  transform(value: string | InitialsSource | null | undefined, lastName?: string | null): string {
    if (value == null || value === '') return '?';

    if (typeof value === 'object') {
      const first = value.firstName?.trim() ?? '';
      const last = value.lastName?.trim() ?? '';
      const fromNames = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
      if (fromNames) return fromNames;

      const usernameInitial = value.username?.trim().charAt(0);
      return usernameInitial ? usernameInitial.toUpperCase() : '?';
    }

    const first = value.trim();
    const last = lastName?.trim() ?? '';
    const fromParts = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
    if (last && fromParts) return fromParts;

    const words = first.split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
      return `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`.toUpperCase();
    }

    return first.charAt(0).toUpperCase() || '?';
  }
}
